// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1aceA","inner":"Footer_inner__2QDwU"};